import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { fetchProductsWarehouseCategories } from './../../../actions/items';
import Select from '../../../components/common/Select';
import { useAutoTranslation } from '../../../helpers/useAutoTranslation';

const CategoriesListBlock = (props) => {
  const { currentProduct, handleChangeInput } = props;

  const { t } = useAutoTranslation();

  const dispatch = useDispatch();
  const [categories, setCategories] = useState(null);

  useEffect(() => {
    dispatch(fetchProductsWarehouseCategories()).then((res) =>
      setCategories(
        res.items.map((item) => ({
          value: item.code,
          label: item.title,
        })),
      ),
    );
  }, [dispatch]);

  const handleOptions = async (value) => {
    handleChangeInput('warehouseCategoryCode', value.value);
  };

  return (
    <div className="row mt-1 mb-2">
      <div className="col-12">
        <Select
          label={t('Складская категория')}
          options={categories}
          onChange={(option) => handleOptions(option)}
          placeholder={`${t('Выберите категорию')}...`}
          defaultValue={
            currentProduct?.warehouseCategoryCode
              ? {
                  value: currentProduct.warehouseCategoryCode,
                  label: currentProduct.warehouseCategoryTitle,
                }
              : null
          }
        />
      </div>
    </div>
  );
};

export default CategoriesListBlock;
